'use strict';

export const ACTIVE_TIMERS_LIST_NAME = 'activeTimers';
export const ACTIVE_TIMERS_LIST_PREFIX = `@@${ACTIVE_TIMERS_LIST_NAME}`;
export const ASSET_TASK_LOG_NAME = 'assetTaskTimerLog';
export const ASSET_TASK_LOG_PREFIX = `@@${ASSET_TASK_LOG_NAME}`;
export const PROJECT_TASK_LOG_NAME = 'projectTaskTimerLog';
export const PROJECT_TASK_LOG_PREFIX = `@@${PROJECT_TASK_LOG_NAME}`;
export const TIMER_EXPORT_NAME = 'timerExport';
export const TIMER_EXPORT_PREFIX = `@@${TIMER_EXPORT_NAME}`;



// WEBPACK FOOTER //
// ./src/js/timers/redux/state.js